import React from "react";
import Button from "@mui/material/Button";
import buttonStyles from "./../../styles/Atoms/Button/ButtonComponent";

function ButtonComponent({
  label,
  onClick,
  backgroundColor,
  color,
  disabled,
  width = '100%',
  icon
}) {
  return (
    <Button
      sx={{
        ...buttonStyles.buttonStyle,
        backgroundColor: backgroundColor,
        color: color,
        width: width,
        fontFamily: 'Raleway, sans-serif',
        fontSize:"13px",
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        "&:hover": {
          //you want this to be the same as the backgroundColor above
          backgroundColor: backgroundColor,
        }
      }}
      variant="contained"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      startIcon={icon}
    >
      {label}
    </Button>
  );
}

export default ButtonComponent;
